// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"147":"109b5786","244":"8b5360e1","468":"109b5786","652":"8b5360e1"}[chunkId] + ".chunk.css";
};